import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppService } from 'src/app/service/app.service';
import { DataService } from 'src/app/service/data.service';

@Component({
  selector: 'app-wayyak-component',
  templateUrl: './wayyak-component.component.html',
  styleUrls: ['./wayyak-component.component.scss'],
})
export class WayyakComponentComponent implements OnInit {

  @Input() activeAmount: string;
  @ViewChild('inputId', { static: false }) ionInput;

  progressState = 1;
  amount: any;
  keyboard = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, '', 'delete'];
  phoneNumber: any = '99999999';
  remark:String;
  success = false;
  succesLottie: any = {
    path: 'assets/lotties/wayyak.json',
    renderer: 'canvas',
    autoplay: true,
    loop: false
  };

  failLottie: any = {
    path: 'assets/lotties/fail.json',
    renderer: 'canvas',
    autoplay: true,
    loop: false
  };
  phoneNumberForm: FormGroup;
  inValidForm = false;

  constructor(public dataService: DataService,
    public appService: AppService,
    public fb: FormBuilder) {
  }

  ngOnInit() {
    this.phoneNumberForm = this.fb.group({
      phoneNumber: ['', [Validators.pattern(/^-?(0|[1-9]\d*)?$/), Validators.required, Validators.maxLength(8), Validators.minLength(8)]],
    });
    this.amount = parseFloat(this.activeAmount);
    setTimeout(() => {
      this.ionInput.setFocus();
    }, 500);
  }


  /**
  * @method { Method will concat the user entering phone number}
  * @memberof HomePage
  */
  addPhonenumber(key) {
    if (key === 'delete') {
      if (this.phoneNumber !== '99999999') {
        this.phoneNumber = this.phoneNumber.slice(0, -1);
        this.phoneNumberForm.controls['phoneNumber'].setValue(this.phoneNumber);
      }
      if (this.phoneNumber.length === 0) {
        this.phoneNumber = '99999999';
        this.phoneNumberForm.controls['phoneNumber'].setValue(this.phoneNumber);
      }
    } else if (this.phoneNumber === '99999999' && key !== 'delete') {
      this.phoneNumber = '';
      this.phoneNumber += key;
      this.phoneNumberForm.controls['phoneNumber'].setValue(this.phoneNumber);
    } else {
      if (this.phoneNumber.length < 8) {
        this.phoneNumber += key;
        this.phoneNumberForm.controls['phoneNumber'].setValue(this.phoneNumber);
      }
    }
  }

  inputNumber(event) {
    if (this.phoneNumber === '99999999') {
      this.phoneNumberForm.controls['phoneNumber'].setValue(event.detail.data);
    }
  }


  /**
  * @method { Method will initiate the wayyak }
  * @memberof HomePage
  */
  initWayyakTransaction() {
    if (this.phoneNumberForm.valid && this.phoneNumber !== '99999999') {
      this.inValidForm = false;
      this.progressState = 2;
      this.createWayyak();
    } else {
      this.inValidForm = true;
    }
  }


  /**
  * @method { Method will POST the wayyak }
  * @memberof HomePage
  */
  createWayyak() {
    let params = {
      mobilePhone: this.phoneNumber,
      amount: parseFloat(this.activeAmount),
      remark: this.remark
    };

    this.dataService.createWayyak(params).subscribe(res => {
      this.successTrnsaction();
    }, err => {
      this.failedTransaction(err);
    });
  }



  /**
  * @method { method will manage state in success transaction }
  */
  successTrnsaction() {
    setTimeout(() => {
      this.success = true;
      this.progressState = 3;
    }, 800);
  }


  /**
  * @method { method will manage state in fail transaction }
  */
  failedTransaction(err) {
    setTimeout(() => {
      this.success = false;
      this.progressState = 3;
      this.appService.toastMessage(err.error.description);
    }, 800);
  }


  /**
   * @method { method will manage state to retry  }
  */
  retry() {
    this.progressState = 1;
  }

  ngOnDestroy() {
    this.amount = null;
  }

}